import type { I18nFn } from '#/i18n/types/I18nFn';
import { ApiOrgType } from '#/modules/listing/orgs/api/types/ApiOrgType';

export const ORG_TYPES = (i18n: I18nFn) =>
  ({
    [ApiOrgType.NONPROFIT]: i18n('Nonprofit'),
    [ApiOrgType.GOVERNMENT]: i18n('Government'),
    [ApiOrgType.CORPORATION]: i18n('Business'),
    [ApiOrgType.CONSULTANT]: i18n('Consultant'),
    [ApiOrgType.RECRUITER]: i18n('Recruiter'),
    [ApiOrgType.COMMUNITY]: i18n('Community Group'),
  }) satisfies Record<ApiOrgType, string>;

export const ORG_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const ORG_TYPE_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(ORG_TYPES(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
